import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { DefaultButton, PrimaryButton, ActionButton } from "office-ui-fabric-react/lib/Button";

import {
  Dialog,
  DialogType,
  DialogFooter,
  DialogContent
} from "office-ui-fabric-react/lib-commonjs/Dialog";
import {
  switchLogoutDialogVisibility,
  showSubmitDialog
} from "../../../actions/topbar-actions";
import {
  scaleStage,
  positionStage,
  getStageScale,
  getStagePosition
} from "../../../actions/viewport-actions";
import {
  togglePdfModal,
  togglePipesPdfModal
} from "../../../actions/pdf-actions";
import {
  runSaveProjectAction
} from "../../../actions/project-actions";
import {
  setActiveRegion,
  setSystemUnit,
  setActiveLanguage
} from "../../../actions/localization-actions";
import { auth } from "../../../lib/authentication";
import { switchIsSigningInProcess, loginUser, logoutUser } from "../../../actions/authentication-actions";
import { buildProjectAutomation, buildPipeProjectAutomation } from "../../../actions/submit-dialog-actions";
import BlockUi from "react-block-ui";
import { toggleTutorialAction } from "../../../actions/tutorial-actions";
import { toast } from "react-toastify";
import { setProjectStatus } from "../../../actions/project-actions";
import { toggleProjectsCrudModal } from "../../../actions/project-crud-actions";
import Project from "../../../lib/project";
import {
  GLOBAL_PROJECT_TYPE_PIPE,
  GLOBAL_PROJECT_TYPE_CHAMBER,
  CHAMBER_TYPE_ID_MC4500
} from "../../../lib/types";
import { saveUserLocalizationDefaults } from "../../../lib/localization/regions";
import "./top-bar.css";
import MiniCADAPI from "../../../lib/MiniCADAPI";
import { languageIds } from "../../../lib/localization/languageIds";
import { getAlertMailtoTemplate, getProcessingCriteria } from "../../../lib/misc/misc_utils";
import { clearRulersOnScreen } from "../../../actions/drawingtoolbar-actions";
import ManifoldSelectors from "../../../reducers/main-manifold-reducer";
import { modalAlertActions } from "../../../actions/modal-alert.actions";
import { setDisableLayerLoginDialog } from '../../../actions/generic-globals.actions';

//#region Remove After Debugging
import { addNewBed, convertToMultiBedProject, updatedSelectedBedValues } from "../../../actions/multi-bed-actions";
import ProjectSelectors from "../../../reducers/project-reducer";
import ProjectService from "../../../lib/services/project-service";
import IconsService from "../../../lib/services/icons-service";
import { switchClearDialogVisibility, switchCreateDialogVisibility } from "../../../actions/apptoolbar-actions";
import SubProject from "../../../lib/sub-project";
import { Toggle } from "office-ui-fabric-react/lib-commonjs/Toggle";
import * as featureFlags from "../../../lib/datasets/featureFlags.json";

//#endregion

// Tutorial actions
import {
  toggleTutorialStartDialog,
} from "../../../actions/tutorial-actions";

const topButtonWidth = "110px";

class TopBarComponent extends PureComponent {
  state = {
    hideDialog: true,
    hideLevel3Alert: true,
    hideLevel2Alert: true,
    hideLevel1Alert: true,
    hide4500Dialog: true,
    hide7200Dialog: true,
    alertLevel: '',
    changeHome: true,
    videoButton: true,
    changeSubmit: true,
    changeCreateAccount: true,
    changeSignIn: true,
    changeNeedHelp: true,
    changeStormTech: true,
    isAuthenticating: false,
    changePrintSystem: true,
    changeEmailDrawings: true,
    requestingDrawings: false,
    changeCurrentProject: true,
    changeManageProjects: true,
    hideEmptySystemDialog: true,
    modalProps: {
      titleAriaId: 'myLabelId',
      subtitleAriaId: 'mySubTextId',
      isBlocking: true,
      containerClassName: 'ms-dialogMainOverride',
    },
    hydroCadToggle: true,
    processingEntity: {},
    hideGlobalWarningSystemDialog: !featureFlags.globalWarningSystemDialog.showWarningSystemDialog,
    hideSubmitChamberWarningMessageDialog: true, //Errors on Click SUBMIT, always true
    enableSubmitChamberWarningMessageDialog: false, // remember to update on drawingsAndReports.component.js SET TO TRUE TO SHOW
  };

  regionButtonRef = null;

  get isUserSignIn() {
    return !!this.props.user;
  }

  /**
   * Updates userData saved on defaults for the user
   * @param userInfo
   * @returns {Promise<*>}
   */
  async updateUserLocaleData(userInfo) {
    try {
      if (!userInfo.userData || !userInfo.userData.region) {
        const userData = await MiniCADAPI.upsertUserRecord(
          {
            userId: userInfo.user.id,
            regionId: this.props.region.id,
            languageId: this.props.language.id,
            unit: this.props.unit,
          },
          userInfo.resourcesTokens.users.tableToken,
        );

        userInfo.userData = {
          region: userData.region ? userData.region._ : this.props.region.id,
          language: userData.language ? userData.language._ : this.props.language.id,
          unit: userData.unit ? userData.unit._ : this.props.unit,
        };
      }
    } catch (error) {
      console.info(`TopBarComponent.updateUserLocaleData() ${error.message}`);
    }
    return userInfo;
  }

  componentDidMount() {
    /* first set state to authenticate */
    this.setState({
      isAuthenticating: true,
    });

    this.setState({ hide7200Dialog: false });

    /* try to load user from cache */
    auth
      .loadFromCache()
      .then(async (info) => {
        if (info) {
          info = await this.updateUserLocaleData(info);

          const b2cData = await MiniCADAPI.getB2CUser(
            info.resourcesTokens.users.adToken,
            info.accessToken.uniqueId
          );
          const userData = await MiniCADAPI.getUserRecord(
            info.user.id,
            info.resourcesTokens.users.tableToken
          );
          await MiniCADAPI.setB2cUsersDepartment(info.resourcesTokens.users.adToken, info.accessToken.uniqueId);

          this.props.loginUser({
            ...info,
            b2cData: b2cData,
            county: userData.county,
            mailingList: userData.mailingList
          });

          toast.info(
            this.props.content[this.props.lang].automaticallySignedIn, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000,
          });
        } else {

          if (
            !this.props.regionSelected &&
            this.props.projectType === GLOBAL_PROJECT_TYPE_CHAMBER
          ) {
            setTimeout(() => {
              this.regionButtonRef.openMenu(true);
            }, 1000);
          }
        }
        this.setState({
          isAuthenticating: false,
        });
      })
      .catch((error) => {
        this.setState({
          isAuthenticating: false,
        });
        console.warn('componentDidMount()->auth.loadFromCache(): Please Sign in again');
        console.warn(`:: ${error.message}`);
      });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.project !== prevProps.project || this.props.user !== prevProps.user) {
      this.setProcessingEntity();
    }

    if (this.props.region.id !== prevProps.region.id) {
      this.setState({ hide7200Dialog: false });
    }

    if (
      this.props.region.id !== prevProps.region.id &&
      this.props.region.id === 'usa' &&
      this.props.chamberType.id === 'MC-4500'
    ) {
      this.setState({
        hide4500Dialog: false,
      });
    }

    if (this.props.projectType !== 'CHAMBER' && this.state.hydroCadToggle === true) {
      console.log('componentDidUpdate()->this.state.hydroCadToggle to FALSE: ');
      this.setState({
        hydroCadToggle: false,
      });
    }
  }

  async zoom(scaleX, scaleY, positionX, positionY) {
    this.props.scaleStage(scaleX, scaleY);
    this.props.positionStage(positionX, positionY);
  }

  async submitProjectAutomation() {
    console.log('async submitProjectAutomation()');
    setTimeout(() => {
      this.setState({
        requestingDrawings: true,
      });
    });

    /* getting stage position and scale from thunk */
    let stageScale = this.props.getStageScale();
    let stagePosition = this.props.getStagePosition();
    let project_instance = ProjectService.getNewProjectInstance(this.props.project);

    project_instance.generateHydroCAD = this.state.hydroCadToggle;

    if (!project_instance.isMultiBedProject) {
      this.zoom(1.0, 1.0, 0.0, 0.0)
        .then(async () => {
          let state;
          if (this.props.projectType === GLOBAL_PROJECT_TYPE_CHAMBER) {
            state = this.props.buildProjectAutomation();
          } else {
            state = this.props.buildPipeProjectAutomation();
          }

          state = JSON.parse(state.serialize());

          await project_instance.persistAutomationState(
            state,
            this.props.user.id,
            this.props.resourcesTokens.projects.blobToken,
          );

          await project_instance.persist(this.props.user.id, this.props.resourcesTokens.projects.tableToken);

          console.log('this.state.hydroCadToggle', this.state.hydroCadToggle);

          let status = await project_instance.submitAutomationTask(
            this.props.user.id,
            this.props.idToken,
            this.props.user.mail,
            this.props.accessToken,
            this.state.hydroCadToggle,
          );

          if (status) {
            if (status.workItemStatus.includes('fail')) {
              status.workItemStatus = Project.PROCESSING_STATUS.failed;
              //status = Project.PROCESSING_STATUS.failed;
            }

            this.props.setProjectStatus(status);
            toast.info(this.props.content[this.props.lang].yourDrawingsAreBeignGenerated, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 4000,
            });
          } else {
            toast.error(this.props.content[this.props.lang].unableToRequestDrawings, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 4000,
            });
          }

          await this.zoom(stageScale.scaleX, stageScale.scaleY, stagePosition.positionX, stagePosition.positionY);

          this.closeDialog();
        })
        .catch((error) => {
          console.error(`(!isMultiBedProject) submitProjectAutomation() this.zoom() :: ${error.message}`);
          this.closeDialog();
        });
    } else {
      this.zoom(1.0, 1.0, 0.0, 0.0)
        .then(async () => {
          const beds = this.props.multiBed.beds;
          let state;

          // Synchronize units on multibeds

          for (let bed of beds) {
            const subProjectInstance = new SubProject(bed.id);
            let automation = await subProjectInstance.fetchAutomationState(
              this.props.user.id,
              this.props.resourcesTokens.projects.blobToken,
            );
            automation.language = this.props.project.language;
            automation.region = this.props.project.region;
            automation.units = this.props.unit;
            automation.email.unitName = 'en1';
            await subProjectInstance.persistAutomationState(
              automation,
              this.props.user.id,
              this.props.resourcesTokens.projects.blobToken,
            );
          }

          // EO - Synchronize units on multibeds

          if (this.props.projectType === GLOBAL_PROJECT_TYPE_CHAMBER) {
            state = this.props.buildProjectAutomation();
          } else {
            state = this.props.buildPipeProjectAutomation();
          }

          state = JSON.parse(state.serialize());

          await project_instance.persistAutomationState(
            state,
            this.props.user.id,
            this.props.resourcesTokens.projects.blobToken,
          );

          await project_instance.persist(this.props.user.id, this.props.resourcesTokens.projects.tableToken);

          let status = await project_instance.submitAutomationTask(
            this.props.user.id,
            this.props.idToken,
            this.props.user.mail,
            this.props.accessToken,
          );
          if (status) {
            if (status.workItemStatus.includes('fail')) {
              status.workItemStatus = Project.PROCESSING_STATUS.failed;
            }

            this.props.setProjectStatus(status);
            toast.info(this.props.content[this.props.lang].yourDrawingsAreBeignGenerated, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 4000,
            });
          } else {
            toast.error(this.props.content[this.props.lang].unableToRequestDrawings, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 4000,
            });
          }
          this.zoom(stageScale.scaleX, stageScale.scaleY, stagePosition.positionX, stagePosition.positionY);
          this.closeDialog();
        })
        .catch((error) => {
          console.error(`(isMultiBedProject) submitProjectAutomation() this.zoom() :: ${error.message}`);
          this.closeDialog();
        });
    }
  }

  handleSubmitOnclick() {
    this.props.showSubmitDialog();
  }

  handleLoginOnclick() {
    auth
      .login(this.props.lang)
      .then(async (info) => {
        if (info) {
          info = await this.updateUserLocaleData(info);
          const b2cData = await MiniCADAPI.getB2CUser(
            info.resourcesTokens.users.adToken,
            info.accessToken.uniqueId
          );
          const userData = await MiniCADAPI.getUserRecord(
            info.user.id,
            info.resourcesTokens.users.tableToken
          );
          this.props.loginUser({
            ...info,
            b2cData: b2cData,
            county: userData.county,
            mailingList: userData.mailingList
          });
        } else {
          this.props.logoutUser();
        }
      })
      .catch((error) => {
        console.info(`auth.login: ${error.message}`);
        this.props.switchIsSigningInProcess(false);
      });
    /* start the logging process */
    this.props.switchIsSigningInProcess(true);
  }

  handleLogoutOnclick() {
    /* show logout dialog */
    this.props.switchLogoutDialogVisibility(true);
  }

  handleCancelLogoutOnClick() {
    /* hide logout dialog */
    this.props.switchLogoutDialogVisibility(false);
  }

  handleConfirmLogoutOnClick() {
    /* logout user */
    auth.logout();
  }

  setProcessingEntity() {
    let projName = '',
      city = '',
      state = '',
      country = '',
      customer = '',
      email = '',
      company = '',
      phone = '',
      project = this.props.project;

    if (project) {
      projName = project && project.projectName ? project.projectName : '';
      city = project.city;
      state = project.state;
      country = project.country;
      customer = project.engineer;
    }

    if (this.props.user) {
      email = this.props.user.mail;
      company = this.props.user.companyName;
      phone = this.props.user.mobilePhone;
    }
    const chamber = this.props.globals && this.props.globals.chamberType ? this.props.globals.chamberType.name : '';
    const numChambers = this.props.calculations.requiredChambers;
    const unit = this.props.unit;

    this.setState({
      processingEntity: {
        projName: projName,
        city: city,
        state: state,
        country: country,
        customer: customer,
        email: email,
        company: company,
        phone: phone,
        chamber: chamber,
        numChambers: numChambers,
        unit: unit,
        systemVolume: this.props.totalStorageProvided.toFixed(2),
      },
    });
  }

  executeProcessingLog(alertType) {
    try {
      const logDataObject = {
        ...this.state.processingEntity,
      };

      const userData = {
        userId: this.props.user.id,
        projectId: this.props.project.id,
        alertLevel: alertType,
        regionId: this.props.user.region,
        languageId: this.props.user.languageId,
        unit: this.props.unit,
        country: logDataObject.country,
      };

      setTimeout(async () => {
        const processingEntity = this.state.processingEntity;
        await MiniCADAPI.postProjectLogRecord(processingEntity, userData, this.props.idToken, this.props.accessToken);
      }, 200);
    } catch (e) {
      console.error('Error on executeProcessingLog(), err:: ', e.message);
    }
  }

  bedHasActiveComponents() {
    let rows = this.props.chamberRows;
    return rows.some((r) => r.getActiveCount() > 0);
  }

  getTotalNumberOfActiveChambers() {
    return this.props.calculations.requiredChambers;
  }

  getTotalNumberOfManifolds() {
    return this.props.upperManifolds.length + this.props.lowerManifolds.length;
  }

  promptDialog = async () => {
    const { content, lang } = this.props;
    const criteria = getProcessingCriteria() || [];
    this.setProcessingEntity();

    this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
    if (this.bedHasActiveComponents() || this.props.projectType === GLOBAL_PROJECT_TYPE_PIPE) {
      if (this.props.projectType === GLOBAL_PROJECT_TYPE_CHAMBER) {
        // Prevent submission if this project uses the deprecated MC-4500
        if (this.props.globals.chamberType.id === CHAMBER_TYPE_ID_MC4500 && this.props.globals.isMC4500Deprecated) {
          this.props.modalAlertActions({
            text: content[lang].MC4500DeprecationAlert,
            btnText: content[lang].ok,
            toggle: true,
          });
          return;
        }

        if (this.state.enableSubmitChamberWarningMessageDialog) {
          // DO we want to submit or show message
          console.log('%c Show Submit Chamber Warning Message Dialog !!!!! ', 'color:red; background-color:yellow;');
          this.setState({
            hideSubmitChamberWarningMessageDialog: false,
          });
          return;
        }

        const numOfChambers = this.getTotalNumberOfActiveChambers(),
          numOfManifolds = this.getTotalNumberOfManifolds();

        let matchingCriteria = criteria.find((criteriaObj) => {
          return (
            numOfChambers >= criteriaObj['chambersMin'] &&
            numOfChambers <= criteriaObj['chambersMax'] &&
            numOfManifolds >= criteriaObj['manifoldsMin'] &&
            numOfManifolds <= criteriaObj['manifoldsMax']
          );
        });

        if (!matchingCriteria) {
          this.setState({
            hideDialog: false,
          });
        } else {
          // Need to log to the alert table here
          const newState = {
            hideDialog: true,
            hideLevel3Alert: !(matchingCriteria.alertType === 'LEVEL_3'),
            hideLevel2Alert: !(matchingCriteria.alertType === 'LEVEL_2'),
            hideLevel1Alert: !(matchingCriteria.alertType === 'LEVEL_1'),
            alertLevel: matchingCriteria.alertType,
          };
          this.setState({ ...newState });
          console.log({ ...newState });
          this.executeProcessingLog(matchingCriteria.alertType);
        }
      } else {
        this.setState({
          hideDialog: false,
        });
      }
    } else {
      this.setState({
        hideEmptySystemDialog: false,
      });
    }
  };

  closeDialog = () => {
    this.setState({
      requestingDrawings: false,
      hideDialog: true,
      hide4500Dialog: true,
      hideLevel3Alert: true,
      hideLevel2Alert: true,
      hideLevel1Alert: true,
    });
  };

  clickSave = () => {
    this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
    this.props.runSaveProjectAction(true);
  };

  processingStatusIsWritable(status) {
    return status === Project.PROCESSING_STATUS.pending || !this.props.user;
  }

  handleRegionOptionsChanged(regionId) {
    /*if (this.props.region.id === regionIds.usa
        && regionId !== regionIds.usa
        && this.props.chamberType.id === CHAMBER_TYPE_ID_MC7200
        && !this.props.isMC4500Deprecated) {
        this.props.modalAlertActions({
            text: this.props.content[this.props.lang].mc7200ChangeRegionAlert,
            toggle: true,
            btnText: this.props.content[this.props.lang].ok,
        });
    } else {

    }*/

    localStorage.setItem('regionDefined', regionId);
    this.props.setActiveRegion(regionId);
  }

  handleLanguageOptionsChanged(languageId) {
    if (!localStorage.getItem('regionDefined')) {
      localStorage.setItem('regionDefined', this.props.region.id);
    }
    localStorage.setItem('languageDefined', languageId);
    this.props.setActiveLanguage(languageId);
  }

  handleUnitsOptionsChanged(unitId) {
    localStorage.setItem('unitDefined', unitId);
    this.props.setSystemUnit(unitId);
  }

  handleLocalizationSetDefault() {
    if (this.isUserSignIn) {
      saveUserLocalizationDefaults(
        this.props.user.id,
        this.props.region.id,
        this.props.language.id,
        this.props.unit,
        this.props.resourcesTokens.users.tableToken,
        this.props.user.county
      ).then(
        (result) => {
          if (result) {
            toast.info(this.props.content[this.props.lang].localizationDefaultsSaved, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 4000,
            });
          }
        },
        (err) => {
          console.log('Failed to update users default localization data:', err);
        },
      );
    }
  }

  /*handleCancelClearOnClick() {
    /!* hide clear dialog *!/
    this.props.switchCreateDialogVisibility(false);
  }*/

  render() {
    const {
      lang,
      content,
      projectType,
      togglePdfModal,
      togglePipesPdfModal,
      toggleTutorialAction,
      toggleProjectsCrudModal,
    } = this.props;
    const { isAuthenticating } = this.state;

    /*const onShowMenuClicked = () => {
      toggleTutorialAction(true);
    };*/

    const handleClearButtonClick = () => {
      this.props.switchCreateDialogVisibility(true);
    };

    const isDeskTop = !!window._bridge;

    const canSubmit =
      (isDeskTop &&
        ((this.props.multiBedIsFromDesktop && this.props.multiBedIsMultiBedDesktopEnabled) ||
          window._projectType === this.props.projectType)) ||
      this.props.enableDebugging;

    const handleClick = (e, func, isButtonDisabled) => {
      if (isButtonDisabled) {
        e.preventDefault();
        this.props.setDisableLayerLoginDialog(true);
      } else {
        // If the button is not "disabled", call the passed callback function
        func();
      }
    };

    const renderProjectButton = (title, func, color, disabled, iconName = null, className) => {
      let buttonStyle = {
        height: '62px',
        width: topButtonWidth,
      };
      if (lang === languageIds.deDE) {
        buttonStyle.overflowWrap = 'anywhere';
        buttonStyle.paddingLeft = buttonStyle.paddingRight = 0;
      }
      if (color === 'changeEmailDrawings') {
        buttonStyle.paddingLeft = 0;
        buttonStyle.paddingRight = 0;
      }
      return (
        <ActionButton
          text={title}
          onClick={(e) => handleClick(e, func, !this.isUserSignIn)}
          disabled={this.isUserSignIn ? disabled : false}
          // TODO: CULTEC - temporarily disable until needed.
          /// disabled={true}
          className={`main_header_actions_bar_button ${className}`}
          onMouseLeave={() => this.setState({ [`${color}`]: !this.state[`${color}`] })}
          onMouseEnter={() => this.setState({ [`${color}`]: !this.state[`${color}`] })}
          iconProps={iconName ? { style: IconsService.getIcon(IconsService.ICONS[iconName]) } : null}
        />
      );
    };

    let disableRequestDrawings =
      !this.props.project ||
      !this.props.project.id ||
      (this.props.project.processingStatus !== Project.PROCESSING_STATUS.unsubmitted &&
        this.props.project.processingStatus !== Project.PROCESSING_STATUS.success &&
        this.props.project.processingStatus !== Project.PROCESSING_STATUS.failed);

    const protectedUnitString = this.props.unit ? content[lang][this.props.unit] : 'Imperial';
    const minWidth = parseInt((window.innerWidth * 0.4).toString(), 10);
    return (
      <React.Fragment>
        <div className="ms-Grid-row main_header_container">
          <div className="ms-Grid-col main_header_logo_block">
            <div className="logo" />
          </div>
          <div className="ms-Grid-col main_header_actions_bar_block">
            {/* create, save manage block */}
            <div className="main_header_actions_bar_inner_block manageProjectsTopbar">
              {renderProjectButton(
                content[lang].createNewProject,
                () => {
                  this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                  handleClearButtonClick();
                },
                'changeManageProjects',
                !this.isUserSignIn,
                IconsService.ICONS.iconCreateNewProject,
              )}
              {(() => {
                const status =
                  this.props.project === null
                    ? Project.PROCESSING_STATUS.unsubmitted
                    : this.props.project.processingStatus;
                return renderProjectButton(
                  content[lang].saveCurrentProject,
                  this.clickSave,
                  'changeCurrentProject',
                  this.processingStatusIsWritable(status),
                  IconsService.ICONS.iconSaveProject,
                  'saveProjectBtn',
                );
              })()}
              {renderProjectButton(
                content[lang].manageProjects,
                () => {
                  this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                  toggleProjectsCrudModal(true);
                },
                'changeManageProjects',
                !this.isUserSignIn,
                IconsService.ICONS.iconManageProjects,
              )}
            </div>
            <div className="main_header_actions_bar_divider" />

            {/* email, print block */}
            <div
              className="main_header_actions_bar_inner_block emailAndPrintBlockTopbar"
              style={{ paddingRight: '2.5rem' }}>
              {projectType === GLOBAL_PROJECT_TYPE_CHAMBER ? (
                <React.Fragment>
                  {renderProjectButton(
                    content[lang].emailDrawingAndReports,
                    async () => this.promptDialog(),
                    'changeEmailDrawings',
                    disableRequestDrawings,
                    IconsService.ICONS.iconEmailBoards,
                    'emailDrawingsBtn',
                  )}
                  {renderProjectButton(
                    content[lang].printSystemSpecifications,
                    () => {
                      this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                      togglePdfModal(true);
                    },
                    'changePrintSystem',
                    false,
                    IconsService.ICONS.iconPrintSystem,
                  )}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {renderProjectButton(
                    content[lang].emailDrawingAndReports,
                    async () => this.promptDialog(),
                    'changeEmailDrawings',
                    disableRequestDrawings,
                    IconsService.ICONS.iconEmailBoards,
                  )}
                  {renderProjectButton(
                    content[lang].printPipeSpecifications,
                    () => {
                      this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                      togglePipesPdfModal(true);
                    },
                    'changePrintSystem',
                    false,
                    IconsService.ICONS.iconPrintSystem,
                  )}
                </React.Fragment>
              )}
            </div>
            {/* design tool block DO NOT REMOVE */}
            {/*<ActionButton
                text={content[lang].instructionalVideo}
                onMouseLeave={() => this.setState({ videoButton: true })}
                onMouseEnter={() => this.setState({ videoButton: false })}
                onClick={() => window.open("https://www.adspipe.com/resources/video-library/stormtech-video-library")}
                className={"main_header_actions_bar_button"}
                iconProps={{ style: IconsService.getIcon(IconsService.ICONS.iconHelp) }}
              />*/}
            {canSubmit ? (
              <React.Fragment>
                <div className="main_header_actions_bar_divider" />
                <div className="main_header_actions_bar_inner_block">
                  <ActionButton
                    // hidden={this.props.isMultiBedProject && this.props.multiBedIsFromDesktop && this.props.multiBedIsMultiBedDesktopEnabled}
                    text={content[lang].submit}
                    onClick={() => this.handleSubmitOnclick()}
                    onMouseLeave={() => this.setState({ changeSubmit: true })}
                    onMouseEnter={() => this.setState({ changeSubmit: false })}
                    className={'main_header_actions_bar_button'}
                    iconProps={{
                      style: IconsService.getIcon(IconsService.ICONS.autodeskInventorLogo, '24px 24px', '24px', '24px'),
                    }}
                  />
                </div>
              </React.Fragment>
            ) : (
              ''
            )}

            <div className="main_header_actions_bar_divider" />

            {/* regional, language block */}
            <div className="main_header_actions_bar_inner_block">
              {projectType === GLOBAL_PROJECT_TYPE_CHAMBER ? (
                <div className="localization-container">
                  <div className="region-lang-container-r1">
                    {
                      <ActionButton
                        className="main_header_actions_localization_button first"
                        style={{ height: this.isUserSignIn ? '43px' : '62px' }}
                        open={!this.props.regionSelected}
                        componentRef={(ref) => (this.regionButtonRef = ref)}
                        iconProps={{
                          style: IconsService.getIcon(IconsService.ICONS.iconGlobeCountry, '32px', '30px', '34px'),
                        }}
                        text={this.props.region.name}
                        title={content[lang].regionButtonTooltip}
                        menuProps={{
                          items: this.props.regions.map((region) => {
                            return {
                              key: region.id,
                              text: region.name,
                              iconProps: {
                                style: IconsService.getIcon(
                                  IconsService.ICONS.iconGlobeCountry,
                                  '32px',
                                  '30px',
                                  '34px',
                                ),
                              },
                              onClick: () => this.handleRegionOptionsChanged(region.id),
                            };
                          }),
                        }}
                      />
                    }
                    {
                      <ActionButton
                        className="main_header_actions_localization_button"
                        iconProps={{
                          style: IconsService.getIcon(IconsService.ICONS.iconLanguage, '32px', '30px', '34px'),
                        }}
                        text={this.props.language.name}
                        style={{ height: this.isUserSignIn ? '43px' : '62px' }}
                        title={content[lang].languageButtonTooltip}
                        menuProps={{
                          items: this.props.region.languages.map((language) => {
                            return {
                              key: language.id,
                              text: language.name,
                              iconProps: {
                                style: IconsService.getIcon(IconsService.ICONS.iconLanguage, '32px', '30px', '34px'),
                              },
                              onClick: () => this.handleLanguageOptionsChanged(language.id),
                            };
                          }),
                        }}
                      />
                    }
                    {
                      <ActionButton
                        className="main_header_actions_localization_button last"
                        iconProps={{
                          style: IconsService.getIcon(IconsService.ICONS.iconImperial, '32px', '30px', '34px'),
                        }}
                        text={protectedUnitString}
                        style={{ height: this.isUserSignIn ? '43px' : '62px' }}
                        title={content[lang]['languageButtonTooltip']}
                        menuProps={{
                          items:
                            this.props.units && this.props.units.length > 0
                              ? this.props.units.map((unit) => {
                                  try {
                                    return {
                                      key: unit.id,
                                      text: content[lang][unit.name],
                                      iconProps: {
                                        style: IconsService.getIcon(
                                          IconsService.ICONS.iconImperial,
                                          '32px',
                                          '30px',
                                          '34px',
                                        ),
                                      },
                                      onClick: () => this.handleUnitsOptionsChanged(unit.id),
                                    };
                                  } catch (error) {
                                    return null;
                                  }
                                })
                              : null,
                        }}
                      />
                    }
                  </div>
                  <div className="region-lang-container-r2">
                    {this.isUserSignIn ? (
                      <ActionButton
                        className="main_header_actions_localization_button"
                        style={{ borderBottom: '0 none transparent' }}
                        iconProps={{
                          style: IconsService.getIcon(IconsService.ICONS.iconSaveAsDefaults, '31px', '24px', '34px'),
                        }}
                        text={content[lang].setAsDefault}
                        onClick={() => this.handleLocalizationSetDefault()}
                      />
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>

            <div className="main_header_actions_bar_divider" />

            {/* user block */}
            <div className="main_header_actions_bar_inner_block">
              <ActionButton
                text={'Tutorial'}
                onClick={() => {
                  this.props.toggleTutorialStartDialog(true);
                }}
                className={'main_header_actions_bar_button'}
                iconProps={{
                  style: IconsService.getIcon(IconsService.ICONS.iconHelp),
                }}
              />
            </div>
            <div className="main_header_actions_bar_inner_block">
              {!this.props.user ? (
                <React.Fragment>
                  <BlockUi tag="span" blocking={isAuthenticating} style={{ ...css.loadingLogin }}>
                    <ActionButton
                      onClick={() => (this.props.user ? this.handleLogoutOnclick() : this.handleLoginOnclick())}
                      text={content[lang].createAccount}
                      onMouseLeave={() => this.setState({ changeCreateAccount: true })}
                      onMouseEnter={() => this.setState({ changeCreateAccount: false })}
                      className={'main_header_actions_bar_button'}
                      iconProps={{ style: IconsService.getIcon(IconsService.ICONS.iconNewAccount) }}
                    />
                  </BlockUi>
                  &nbsp;&nbsp;
                </React.Fragment>
              ) : (
                ''
              )}

              <BlockUi tag="span" blocking={isAuthenticating} style={{ ...css.loadingLogin }}>
                <ActionButton
                  onClick={() => (this.props.user ? this.handleLogoutOnclick() : this.handleLoginOnclick())}
                  text={!this.props.user ? content[lang].signIn : content[lang].signOut}
                  onMouseLeave={() => this.setState({ changeSignIn: true })}
                  onMouseEnter={() => this.setState({ changeSignIn: false })}
                  // className={changeSignIn ? "default tutorialSignIn" : "changed tutorialSignIn"}/>
                  className={'main_header_actions_bar_button'}
                  iconProps={{
                    style: IconsService.getIcon(
                      this.props.user ? IconsService.ICONS.iconLogOut : IconsService.ICONS.iconLogOut,
                    ),
                  }}
                />
              </BlockUi>
            </div>

            {/*<div className="needHelpButton"  style={css.showMe2}>
                             {<DefaultButton
                                //text={content[lang].needHelp}
                                // onClick={() => this.setState({hideLevel2Alert: false})}
                                //onClick={() => this.promptDialog()}
                                onMouseLeave={() => this.setState({ changeNeedHelp: true })}
                                onMouseEnter={() => this.setState({ changeNeedHelp: false })}
                                className={changeNeedHelp ? 'needHelpDefault' : 'needHelpChanged'}
                            />}
                            <DefaultButton
                                style={{ display: "none", ...css.showMe3 }}
                                text={content[lang].needHelp}
                                onClick={onShowMenuClicked}
                                onMouseLeave={() => this.setState({ changeNeedHelp: true })}
                                onMouseEnter={() => this.setState({ changeNeedHelp: false })}
                                className={changeNeedHelp ? "needHelpDefault" : "needHelpChanged"}
                            />
                        </div>*/}
          </div>
        </div>

        <Dialog
          hidden={this.state.hideDialog}
          dialogContentProps={{
            type: DialogType.normal,
            title: content[lang].requestDrawings,
            subText: content[lang].requestCurrentProjectDrawings,
          }}
          modalProps={this.state.modalProps}
          onDismiss={this.closeDialog}>
          <BlockUi tag="div" className="loadingBlockUI" blocking={this.state.requestingDrawings}>
            {this.props.projectType === 'CHAMBER' ? (
              <div style={{ color: 'black' }}>
                {/* CULTEC DISABLED
                <Toggle
                  className="Toggle ms-Toggle_green_back"
                  onClick={() => {
                    this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                  }}
                  checked={this.state.hydroCadToggle}
                  onChange={( event, value ) => {
                    this.setState({ hydroCadToggle: value });
                  }
                  }
                  onText={content[lang].includeHydroCADYes}
                  offText={content[lang].includeHydroCADNo}
                />*/}
              </div>
            ) : null}
            <DialogFooter>
              <PrimaryButton onClick={async () => this.submitProjectAutomation()} text={content[lang].request} />
              <DefaultButton
                onClick={async () => this.closeDialog()}
                text={content[lang].cancel}
                className={'outline_grey_ads'}
              />
            </DialogFooter>
          </BlockUi>
        </Dialog>

        <Dialog
          hidden={this.state.hideEmptySystemDialog}
          dialogContentProps={{
            type: DialogType.normal,
            title: this.props.content[this.props.lang].emptySystem,
            subText: this.props.isMultiBedProject
              ? this.props.content[this.props.lang].multiBedPleaseAddComponentsToYourSystem
              : this.props.content[this.props.lang].pleaseAddComponentsToYourSystem,
          }}
          modalProps={this.state.modalProps}
          onDismiss={() => {
            this.setState({ hideEmptySystemDialog: true });
          }}>
          <DialogFooter>
            <PrimaryButton
              onClick={() => {
                this.setState({ hideEmptySystemDialog: true });
              }}
              text={content[lang].ok}
            />
          </DialogFooter>
        </Dialog>

        <Dialog
          hidden={this.state.hideLevel1Alert && this.state.hideLevel2Alert}
          dialogContentProps={{
            type: DialogType.normal,
            style: { minWidth: '450px' },
            titleId: 'alert-level-title',
            title: content[lang].systemProcessingAlertTitle,
            subText: !this.state.hideLevel1Alert
              ? content[lang].systemProcessingAlertLevel1Text
              : content[lang].systemProcessingAlertLevel2Text,
          }}
          modalProps={{ containerClassName: 'alert-level-container' }}
          onDismiss={this.closeDialog}>
          <BlockUi tag="div" className="loadingBlockUI" blocking={this.state.requestingDrawings}>
            <DialogFooter>
              <div className="alert-level-input-container">
                <PrimaryButton onClick={async () => this.submitProjectAutomation()} text={content[lang].request} />
                <DefaultButton
                  onClick={async () => this.closeDialog()}
                  text={content[lang].cancel}
                  className={'outline_grey_ads'}
                />
              </div>
            </DialogFooter>
          </BlockUi>
        </Dialog>

        <Dialog
          hidden={this.state.hideLevel3Alert}
          dialogContentProps={{
            type: DialogType.normal,
            titleId: 'alert-level-3-title',
            title: content[lang].systemProcessingWarningTitle,
            subText: +"<a href='google.com'>Link Here</a>",
          }}
          modalProps={{ containerClassName: 'alert-level-container alert-level-3-container' }}
          onDismiss={this.closeDialog}>
          <BlockUi tag="div" className="loadingBlockUI" blocking={this.state.requestingDrawings}>
            <DialogContent>
              <div
                dangerouslySetInnerHTML={{
                  __html: `${content[lang].systemProcessingAlertLevel3Text.replace(
                    '{0}',
                    `<a href="${getAlertMailtoTemplate(
                      this.state.processingEntity,
                      this.props.region.id,
                      content[lang],
                    )}">ADSDesignTool@ads-pipe.com</a>`,
                  )}`,
                }}
              />
            </DialogContent>
            <DialogFooter>
              <div className="alert-level-input-container">
                <DefaultButton onClick={async () => this.submitProjectAutomation()} text={content[lang].request} />
                <PrimaryButton
                  style={{ width: '150px' }}
                  href={getAlertMailtoTemplate(this.state.processingEntity, this.props.region.id, content[lang])}
                  text={content[lang].emailAds}
                />
                <DefaultButton
                  onClick={async () => this.closeDialog()}
                  text={content[lang].cancel}
                  className={'outline_grey_ads'}
                />
              </div>
            </DialogFooter>
          </BlockUi>
        </Dialog>

        <Dialog
          hidden={!this.props.showLogoutDialog}
          dialogContentProps={{
            type: DialogType.normal,
            title: content[lang].signOutADS,
            subText: content[lang].logoutAnyways,
          }}
          modalProps={{
            isBlocking: true,
            containerClassName: 'ms-dialogMainOverride',
          }}
          Style={{ color: '#000' }}>
          <DialogFooter>
            <PrimaryButton onClick={() => this.handleConfirmLogoutOnClick()} text={content[lang].signOut} />
            <DefaultButton
              onClick={() => this.handleCancelLogoutOnClick()}
              text={content[lang].cancel}
              className={'outline_grey_ads'}
            />
          </DialogFooter>
        </Dialog>

        <Dialog
          hidden={this.state.hide4500Dialog}
          dialogContentProps={{
            type: DialogType.normal,
            title: null, // this.props.content[this.props.lang].titleWarning,
            subText: this.props.content[this.props.lang].chamberTypeChangeOnMC4500Warning,
          }}
          modalProps={this.state.modalProps}
          onDismiss={() => {
            this.setState({ hide4500Dialog: true });
          }}>
          <DialogFooter>
            <PrimaryButton
              onClick={() => {
                this.setState({ hide4500Dialog: true });
              }}
              text={content[lang].ok}
            />
          </DialogFooter>
        </Dialog>

        <Dialog
          // hidden={this.state.hide7200Dialog}
          hidden={true}
          dialogContentProps={{
            type: DialogType.normal,
            // No need for translation. MondayId: 2396502598 3660081060, 4255796856
            subText: 'Did you know? Cultec chambers have a lead time of 2 weeks or less in the US and Canada.',
          }}
          modalProps={{
            isBlocking: false,
            containerClassName: 'ms-dialogMainOverride',
          }}
          onDismiss={() => {
            this.setState({ hide7200Dialog: true });
          }}
          containerClassName="usa_customers_alert"
          minWidth={minWidth}
          maxWidth={minWidth}>
          <DialogFooter>
            <PrimaryButton
              onClick={() => {
                this.setState({ hide7200Dialog: true });
              }}
              text={content[lang].ok}
            />
          </DialogFooter>
        </Dialog>

        <Dialog
          hidden={this.state.hideGlobalWarningSystemDialog}
          dialogContentProps={{
            type: DialogType.normal
          }}
          modalProps={{
            isBlocking: true,
            containerClassName: "ms-dialogMainOverride"
          }}
          onDismiss={() => {
            this.setState({ hide7200Dialog: true });
          }}
          containerClassName="usa_customers_alert"
          minWidth={minWidth}
          maxWidth={minWidth}
        >
          <DialogContent>
            <div dangerouslySetInnerHTML={{ __html: featureFlags.globalWarningSystemDialog.mainText }}></div>
          </DialogContent>
          <DialogFooter>
            {( featureFlags.globalWarningSystemDialog.showPrimaryButton ) && ( <PrimaryButton
              onClick={() => {
                this.setState({ hideGlobalWarningSystemDialog: true });
              }}
              text={content[lang].close}
            /> )}
            {( featureFlags.globalWarningSystemDialog.showSecondButton ) && ( <PrimaryButton
              onClick={() => {
                if (featureFlags.globalWarningSystemDialog.enableDismissSecondButton)
                  this.setState({ hideGlobalWarningSystemDialog: true });
                window.open(featureFlags.globalWarningSystemDialog.secondButtonUrl, "_blank");
              }}
              text={featureFlags.globalWarningSystemDialog.secondButtonLabel}
            /> )}
          </DialogFooter>
        </Dialog>

        <Dialog
          hidden={this.state.hideSubmitChamberWarningMessageDialog}
          dialogContentProps={{
            type: DialogType.normal,
            // No need for translation.
            // This is used only to display SUBMIT ERROR MESSAGES,
            subText: '...',
          }}
          modalProps={{
            isBlocking: true,
            containerClassName: 'ms-dialogMainOverride',
          }}
          onDismiss={() => {
            this.setState({ hideSubmitChamberWarningMessageDialog: true });
          }}
          containerClassName="usa_customers_alert"
          minWidth={minWidth}
          maxWidth={minWidth}>
          <DialogFooter>
            <PrimaryButton
              onClick={() => {
                this.setState({ hideSubmitChamberWarningMessageDialog: true });
              }}
              text={content[lang].ok}
            />
          </DialogFooter>
        </Dialog>
      </React.Fragment>
    );
  }
}

const css = {
  loadingLogin: {
    minHeight: '32px',
    display: 'inline-block',
  },
};

const mapStateToProps = (state) => {
  return {
    user: state.authentication.user,
    resourcesTokens: state.authentication.resourcesTokens,
    accessToken: state.authentication.accessToken,
    idToken: state.authentication.idToken,

    showLogoutDialog: state.topbar.showLogoutDialog,

    content: state.localization.content,
    lang: state.localization.lang,
    language: state.localization.language,
    languages: state.localization.languages,
    region: state.localization.region,
    regions: state.localization.regions,
    regionSelected: state.localization.regionChosenByUser,
    unit: state.localization.unit,
    units: state.localization.units,

    unitLbl: state.localization.lbl,
    localization: state.localization,

    project: state.project.project,
    projectInfo: state.project.projectInfo,
    runSaveProject: state.project.runSaveProject,

    projectType: state.globals.projectType,
    enableDebugging: state.globals.enableDebuging,
    globals: state.globals,

    chamberRows: state.chamberbed.chamberRows,

    upperManifolds: ManifoldSelectors.getManifoldsByType('upper'),
    lowerManifolds: ManifoldSelectors.getManifoldsByType('lower'),

    calculations: state.calculations,

    totalStorageProvided: state.calculations.totalStorageProvided,
    isMC4500Deprecated: state.globals.isMC4500Deprecated,
    chamberType: state.globals.chamberType,
    multiBed: state.multiBed,
    isMultiBedProject: ProjectSelectors.isMultiBedProject(),
    multiBedIsFromDesktop: state.multiBed.isFromDesktop,
    multiBedIsMultiBedDesktopEnabled: state.multiBed.isMultiBedDesktopEnabled,
    multiBedBeds: state.multiBed.beds,
  };
};

const mapDispatchToProps = {
  buildPipeProjectAutomation,
  buildProjectAutomation,
  clearRulersOnScreen,
  getStagePosition,
  getStageScale,
  loginUser,
  logoutUser,
  runSaveProjectAction,
  scaleStage,
  positionStage,
  setActiveLanguage,
  setActiveRegion,
  setProjectStatus,
  setSystemUnit,
  showSubmitDialog,
  switchIsSigningInProcess,
  switchLogoutDialogVisibility,
  togglePdfModal,
  togglePipesPdfModal,
  toggleProjectsCrudModal,
  toggleTutorialAction,
  modalAlertActions,
  addNewBed,
  convertToMultiBedProject,
  switchClearDialogVisibility,
  switchCreateDialogVisibility,

  updatedSelectedBedValues,
  setDisableLayerLoginDialog,
  toggleTutorialStartDialog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopBarComponent);



// WEBPACK FOOTER //
// ./src/components/LayoutSections/TopBar/top-bar.component.js